import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle";

import {
    BrowserRouter as Router,
    Routes,
    Route,
    useLocation,
} from "react-router-dom";

import HomePage from "./pages/HomePage";
import MatchSpecification from "./pages/MatchSplecification";
import MatchSpecificationVehiclePage from "./pages/MatchSpecificationVehiclePage";
import ExpectedResults from "./pages/ExpectedResults";
import CreateExpectedResult from "./pages/CreateExpectedResult";
import UpdateExpectedResult from "./pages/UpdateExpectedResult";
import SpcesRatingCategories from "./pages/SpcesRatingCategories";
import SpecsRating from "./pages/SpecsRating";
import Vehicles from "./pages/Vehicles";
import VehicleDetail from "./pages/VehicleDetail";
import VehicleVariantDetail from "./pages/VehicleVariantDetail";
import VehicleVariantsWithoutGallery from "./pages/VehicleVariantsWithoutGallery";
import VehiclesWithoutSpec from "./pages/VehiclesWithoutSpec";
import TableDnd from "./pages/DragAndSort";
import CreateVehicle from "./pages/CreateVehicle";
import CMSEdit from "./pages/CmsEdit";
import EditVehicleCMS from "./pages/EditVehicleCMS";
import PurchaseOrderPivotView from "./pages/PurchaseOrderPivotView";

import Toolsbar from "./components/Toolsbar";
import Login from "./pages/Login";

import RFQTable from "./pages/dashboard_tables/RFQTable";
import POTable from "./pages/dashboard_tables/PoTable";
import ArrivalTable from "./pages/dashboard_tables/ArrivalTable";
import DelayedTable from "./pages/dashboard_tables/DelayedTable";
import DeliveryList from "./pages/DeliveryList";
import BLList from "./pages/BLListView";

import CustomerShippingView from "./pages/customer/CustomerShippingView";
import FullscreenShippingView from "./pages/FullscreenShippingView";

import {
    ProtectedRoute,
    CustomerProtectedRoute,
} from "./components/ProtectedRoute";
import CustomerShippingViewFullScreen from "./pages/customer/CustomerShippingViewFullScreen";

/* -------------------- Layout -------------------- */
function Layout({ children }: { children: React.ReactNode }) {
    const location = useLocation();

    const fullscreenRoutes = [
        "/shipping-fullscreen",
        "/cs-shipping-fullscreen",
    ];
    const isFullscreen = fullscreenRoutes.includes(location.pathname);

    return (
        <>
            {!isFullscreen && <Toolsbar />}

            {children}

            {!isFullscreen && (
                <footer
                    className="bg-light text-center text-lg-start py-3 border-top"
                    style={{
                        position: "fixed",
                        left: 0,
                        bottom: 0,
                        width: "100%",
                        zIndex: 100
                    }}
                >
                    <div className="container text-center">
                        <small className="text-muted">
                            &copy; 2025,{" "}
                            <a
                                href="https://specification.carandx.com"
                                className="text-decoration-none text-muted"
                            >
                                CarandX
                            </a>
                        </small>
                    </div>
                </footer>
            )}
        </>
    );
}

/* -------------------- App -------------------- */
function App() {
    return (
        <Router>
            <Layout>
                <Routes>
                    <Route path="/login" element={<Login />} />

                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <HomePage />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/match-specification"
                        element={
                            <ProtectedRoute>
                                <MatchSpecification />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/match-specification/:vehicleId"
                        element={
                            <ProtectedRoute>
                                <MatchSpecificationVehiclePage />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/expected-results"
                        element={
                            <ProtectedRoute>
                                <ExpectedResults />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/create-expected-result"
                        element={
                            <ProtectedRoute>
                                <CreateExpectedResult />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/expected-result/:id"
                        element={
                            <ProtectedRoute>
                                <UpdateExpectedResult />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/specs-rating-categories"
                        element={
                            <ProtectedRoute>
                                <SpcesRatingCategories />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/specs-rating/:id"
                        element={
                            <ProtectedRoute>
                                <SpecsRating />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/sort"
                        element={
                            <ProtectedRoute>
                                <TableDnd />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/vehicles"
                        element={
                            <ProtectedRoute>
                                <Vehicles />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/vehicle/:id"
                        element={
                            <ProtectedRoute>
                                <VehicleDetail />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/vehicle-variant/:id"
                        element={
                            <ProtectedRoute>
                                <VehicleVariantDetail />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/vehicle-variants-without-gallery"
                        element={
                            <ProtectedRoute>
                                <VehicleVariantsWithoutGallery />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/vehicles-without-spec"
                        element={
                            <ProtectedRoute>
                                <VehiclesWithoutSpec />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/create-vehicle"
                        element={
                            <ProtectedRoute>
                                <CreateVehicle />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/cms-edit"
                        element={
                            <ProtectedRoute>
                                <CMSEdit />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/edit-vehicle-cms/:odooVehicleId"
                        element={
                            <ProtectedRoute>
                                <EditVehicleCMS />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/shipping"
                        element={
                            <ProtectedRoute>
                                <PurchaseOrderPivotView />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/rfq-list"
                        element={
                            <ProtectedRoute>
                                <RFQTable />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/po-list"
                        element={
                            <ProtectedRoute>
                                <POTable />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/arrival-list"
                        element={
                            <ProtectedRoute>
                                <ArrivalTable />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/delayed-list/:startDate/:endDate"
                        element={
                            <ProtectedRoute>
                                <DelayedTable />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/delivery"
                        element={
                            <ProtectedRoute>
                                <DeliveryList />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/bl"
                        element={
                            <ProtectedRoute>
                                <BLList />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/cs-shipping"
                        element={
                            <CustomerProtectedRoute>
                                <CustomerShippingView />
                            </CustomerProtectedRoute>
                        }
                    />

                    {/* FULLSCREEN PAGE (NO TOOLSBAR, NO FOOTER) */}
                    <Route
                        path="/shipping-fullscreen"
                        element={
                            <ProtectedRoute>
                                <FullscreenShippingView />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/cs-shipping-fullscreen"
                        element={
                            <CustomerProtectedRoute>
                                <CustomerShippingViewFullScreen />
                            </CustomerProtectedRoute>
                        }
                    />
                </Routes>
            </Layout>
        </Router>
    );
}

export default App;
